<template>
  <div class="yuyueguahao">
    <van-search v-model="doctorName" placeholder="请输入医生姓名" @search="searchChange" />
    <van-loading v-show="loading" class="my-loading" type="spinner" color="#1989fa" />
    <van-cell-group v-show="!loading" inset style="margin-top:20px;">
      <van-cell v-for="(item,index) in doctorJobList" :key="index" :title="item.titleName||item.deptName" is-link @click="goTo(item)" />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'XuanZeYiSheng',
  data() {
    return {
      type: '',
      loading: false,
      doctorName: '',
      doctorJobList: []
    }
  },
  created() {
    this.type = this.$route.query.type
    this.getData()
  },
  mounted() {

  },
  methods: {
    getData() {
      this.loading = true
      this.$Apis.getSzsgjyyDoctorJobList({
        campusArea: this.type
      }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.doctorJobList = res.data
        } else {
          this.$toast(res.message)
        }
      }).catch(err => {
        this.loading = false
        this.$toast(err.message)
      })
    },
    searchChange() {
      this.$router.push(`/yishengliebiao?doctorName=${this.doctorName}&type=${this.type}`)
    },
    goTo(item) {
      this.$router.push(`/yishengliebiao?titleCode=${item.titleCode || ''}&deptCode=${item.deptCode || ''}&type=${this.type}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.cell-left-icon {
    font-size: 40px;
    margin-right: 10px;
  }
</style>
